/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useHistory } from "react-router-dom";
import { Button, Popover, theme, ModalConfirm } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { useRemoveEnvironment } from "~/hooks/graphql";
import { showSuccess } from "~/services/toast";
import { generateActionConfirmText, handleError, toInputError } from "~/tools";
import { EnvironmentPopoverProps } from "./types";

export function EnvironmentPopover(props: EnvironmentPopoverProps) {
  const [isModalConfirmOpen, setIsModalConfirmOpen] = React.useState(false);

  const [removeEnvironment] = useRemoveEnvironment();

  const history = useHistory();

  const onRemoveHandler = async (nid: string) => {
    try {
      await removeEnvironment({ nid });

      setIsModalConfirmOpen(false);
      showSuccess(SUCCESS_TEXT.environmentRemoved);
      history.push(`/applications/${props.applicationId}`);
    } catch (error) {
      handleError(toInputError(error));
    }
  };

  return (
    <>
      <Popover alignRight trigger={<Button severity="low" icon="menu" />}>
        <Button
          severity="low"
          css={{ backgroundColor: theme.color.background.ui01 }}
          iconRight
          icon="trash"
          onClick={() => setIsModalConfirmOpen(true)}
        >
          Delete Environment
        </Button>
      </Popover>
      <ModalConfirm
        isOpen={isModalConfirmOpen}
        onClose={() => setIsModalConfirmOpen(false)}
        actionLabel="Delete"
        contentLabel="Delete Environment"
        confirm={() => onRemoveHandler(props.nid)}
      >
        {generateActionConfirmText(props.name)("delete")()}
      </ModalConfirm>
    </>
  );
}
